import { isBrowserChrome, isBrowserSafari } from 'owa-user-agent';
import { isFeatureEnabled } from 'owa-feature-flags';

export default function isTabReuseEnabled() {
    const isBrowserSupported =
        ((isBrowserChrome() || isBrowserSafari()) &&
            isFeatureEnabled('fwk-moduleSwitcherReuseTabs')) ||
        isFeatureEnabled('fwk-moduleSwitcherReuseTab-all');

    return isBrowserSupported && typeof localStorage === 'object';
}
